import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/cn";
import { CHATWOOT_BASE_URL } from "@/config/chatwoot";
import { useUiStore } from "@/store/uiStore";
import { useIframeOAuthBreakout } from "@/hooks/useIframeOAuthBreakout";

export const ConversationPanel: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const chatwootTarget = useUiStore((s) => s.chatwootTarget);
  const src = chatwootTarget ?? CHATWOOT_BASE_URL;

  // OAuth providers (Microsoft/Google) refuse to render inside an iframe, so
  // promote the frame's sign-in navigation to the top window on each load.
  const handleOAuthBreakout = useIframeOAuthBreakout();

  // A deep-link target (e.g. Settings → Inboxes) changes the iframe URL, which
  // triggers a fresh navigation — show the loader again until it finishes.
  useEffect(() => {
    setIsLoading(true);
  }, [src]);

  return (
    <div className="relative flex flex-col h-full w-full bg-white overflow-hidden">
      {isLoading ? (
        <div
          className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white"
          aria-live="polite"
          aria-busy="true"
        >
          <Loader2 className="w-10 h-10 text-bridge-accent animate-spin" />
          <p className="mt-4 text-sm font-medium text-slate-600">
            Loading conversations…
          </p>
        </div>
      ) : null}

      <iframe
        src={src}
        className={cn("flex-1 w-full border-none transition-opacity duration-200", isLoading && "opacity-0")}
        title="Chatwoot Conversations"
        allow="camera; microphone; clipboard-read; clipboard-write; display-capture"
        onLoad={(event) => {
          setIsLoading(false);
          handleOAuthBreakout(event);
        }}
      />
    </div>
  );
};
